import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartComponent = () => {
  const data = {
    labels: ["Students", "Teachers", "School Fees", "Salary", "Classes"],
    datasets: [
      {
        label: "Graph Analysics",
        data: [120, 150, 180, 170, 200, 220, 190, 210, 240, 230, 260, 280],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Monthly Student Enrollment",
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChartComponent;
